import Vue from 'vue'
import Vuex from 'vuex'
import activities from './modules/activities'
import auth from './modules/auth'
import companies from './modules/companies'
import createInvoice from './modules/createInvoice'
import createQuote from './modules/createQuote'
import customers from './modules/customers'
import expenses from './modules/expenses'
import invoiceTextTemplates from './modules/invoiceTextTemplates'
import invoices from './modules/invoices'
import items from './modules/items'
import localSettings from './modules/localSettings'
import persons from './modules/persons'
import projects from './modules/projects'
import quoteTextTemplates from './modules/quoteTextTemplates'
import quotes from './modules/quotes'
import statistics from './modules/statistics'
import team from './modules/team'
import timeEntries from './modules/timeEntries'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    activities,
    auth,
    team,
    persons,
    companies,
    customers,
    expenses,
    items,
    statistics,
    invoices,
    invoiceTextTemplates,
    localSettings,
    quotes,
    quoteTextTemplates,
    timeEntries,
    projects,
    createInvoice,
    createQuote
  },
  strict: debug
})

export default store
